import axios from "axios";
import auth from "../auth.js";

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

http.interceptors.request.use(
  config => {
    config.headers["Authorization"] = "Bearer " + auth.getToken();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  res => {
    return res;
  },
  err => {
    const { status: statusCode } = err.response;

    if (statusCode === 401) {
      auth.logout();
      window.location = "/login";
    }
    return Promise.reject(err);
  }
);

export default http;
